var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "15px",
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED031275-E360-4BE8-B37E-A63C69BBB997") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0_ShomreyHaderech_ReportingDetails_Crop",
    transform: "translate(-751.000000, -243.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ant-design_download-outlined",
    transform: "translate(751.000000, 243.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.86524064,10.6747159 C7.88124064,10.6950852 7.90168984,10.7115554 7.92504813,10.7228906 C7.94840642,10.7342259 7.97403209,10.7401065 8,10.7401065 C8.02596791,10.7401065 8.05159358,10.7342259 8.07495187,10.7228906 C8.09828877,10.7115554 8.11875936,10.6950852 8.13475936,10.6747159 L10.5304813,7.65553977 C10.6181818,7.54474432 10.5390374,7.38068182 10.3957219,7.38068182 L8.81069519,7.38068182 L8.81069519,0.170454545 C8.81069519,0.0767045455 8.73368984,0 8.63957219,0 L7.35614973,0 C7.26203209,0 7.18502674,0.0767045455 7.18502674,0.170454545 L7.18502674,7.37855114 L5.60427807,7.37855114 C5.46096257,7.37855114 5.38181818,7.54261364 5.46951872,7.65340909 L7.86524064,10.6747159 Z M15.828877,9.92897727 L14.5454545,9.92897727 C14.4513369,9.92897727 14.3743316,10.0056818 14.3743316,10.0994318 L14.3743316,13.3806818 L1.62566845,13.3806818 L1.62566845,10.0994318 C1.62566845,10.0056818 1.5486631,9.92897727 1.45454545,9.92897727 L0.171122995,9.92897727 C0.0770053476,9.92897727 0,10.0056818 0,10.0994318 L0,14.3181818 C0,14.6953125 0.305882353,15 0.684491979,15 L15.315508,15 C15.6941176,15 16,14.6953125 16,14.3181818 L16,10.0994318 C16,10.0056818 15.9229947,9.92897727 15.828877,9.92897727 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f31b2586db227ab3c2966c68bf2518a6.svg";
export { ForwardRef as ReactComponent };